import axios, { AxiosResponse } from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { IMerchantOrdersInvoice } from '../../interfaces/common/merchant-invoices';
import { AuthContext } from '../../contexts/user-context/user-context';
import { API_ENDPOINT } from '../../configurations/global.config';
import {
  Alert,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
} from '@mui/material';
import { ErrorsFlattenner } from '../common/errors-flattenner/errors-flattenner';
import EditingInvoice from '../delivery-company-components/accouting/invoices/editing-invoice';
import { ClearIcon } from '@mui/x-date-pickers';
import { on } from 'events';
import { isMobile, isTablet } from 'react-device-detect';
import editingInvoice from '../delivery-company-components/accouting/invoices/editing-invoice';
import { IWarehouseShelf } from '../../interfaces/delivery-company/warehouseshelf';
import EditShelfDialog from '../delivery-company-components/warehouse-shelves/shelves-listing/edit-shelf-dialog';

interface ShelfLookupDialogProps {
  shelf_id: string;
  onClose: () => void;
}

function ShelfLookupDialog({ shelf_id, onClose }: ShelfLookupDialogProps) {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<AxiosResponse>();
  const [shelf, setShelf] = useState<IWarehouseShelf>();
  const [message, setMessage] = useState('');
  const { user, config } = useContext(AuthContext);

  useEffect(() => {
    setLoading(true);
    setResponse(undefined);
    const fetchShelf = async () => {
      try {
        const response = await axios.get<IWarehouseShelf>(
          `${API_ENDPOINT}/api/v1/shelf/${shelf_id}/`,
          config
        );
        setResponse(response);
        setShelf(response.data);
      } catch (e) {
        if (axios.isAxiosError(e)) {
          setResponse(e.response);
          setMessage('Failed to find shelf: ' + e.response?.statusText);
        }
        setMessage('Failed to find shelf');
      }
      setLoading(false);
    };

    fetchShelf();
  }, [shelf_id]);
  return loading ? (
    <>
      Looking for shelf <CircularProgress />
    </>
  ) : (
    <>
      {message != '' && (
        <>
          <Alert
            severity={
              response && response.status >= 200 && response.status < 300
                ? 'success'
                : 'error'
            }
          >
            <>
              {message}

              {response && response.status >= 300 && (
                <ErrorsFlattenner rawErrors={response.data} />
              )}
            </>
          </Alert>
          <br />
        </>
      )}

      {shelf && <EditShelfDialog shelf={shelf} onClose={onClose} />}
    </>
  );
}

export default ShelfLookupDialog;
